import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { cn } from "@/lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { Outlet, useLocation, useNavigation } from "react-router";

const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.98,
  },
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 0.98,
  },
};

const pageTransition = {
  type: "tween",
  ease: "easeOut",
  duration: 0.2,
} as const;

export default function MainLayout() {
  const navigation = useNavigation();
  const location = useLocation();

  const isLoading = navigation.state === "loading";

  return (
    <div className="h-full flex w-full">
      <main className={cn("w-full h-[100dvh] relative overflow-hidden")}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="in"
            exit="out"
            variants={pageVariants}
            transition={pageTransition}
            className="absolute inset-0 overflow-y-auto"
          >
            {isLoading ? (
              <div className="p-6 py-4 h-full">
                <LoadingSpinner />
              </div>
            ) : (
              <div className="h-full">
                <Outlet />
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
}

export function HydrateFallback() {
  return (
    <div className="p-6 py-4 h-full flex items-center justify-center gap-6">
      <LoadingSpinner />
    </div>
  );
}
